<template>
  <div>
    <ContactsComponent :settings="settings" />
  </div>
</template>

<script>
export default {
  name: "Contacts",
  props: {
    settings: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ContactsComponent: () => import("../ContactsComponent")
  }
};
</script>
